<mat-card-title class="full-width" fxLayout="row">
    <span>{{data.title}}</span>
</mat-card-title>
<div class="pb-1">
    <mat-divider></mat-divider>
</div>
<form fxLayout="column" fxLayoutGap="40px" [formGroup]="unos">
    <mat-form-field fxFlex="50">
        <mat-label>{{ translatePrefix + "vaziOd" | translate }}</mat-label>
        <input formControlName="vaziOd" data-testid="submissionDateFrom" matInput [matDatepicker]="submissionFrom"
            [min]="minDate" />
        <mat-datepicker-toggle matSuffix [for]="submissionFrom"></mat-datepicker-toggle>
        <mat-datepicker #submissionFrom></mat-datepicker>

        <button type="button" mat-button matSuffix mat-icon-button aria-label="Clear" matTooltipPosition="above"
            (click)="this.vaziOd.reset()">
            <mat-icon>close</mat-icon>
        </button>
        <mat-error *ngIf="vaziOd.invalid" class="alert">
            <span *ngIf="vaziOd.errors['required']">
                {{translatePrefix + "obaveznoPolje" | translate:
                {attributName: translatePrefix + "vaziOd" | translate} }}
            </span>
            <span *ngIf="vaziOd.errors['matDatepickerMin']">
                {{ (translatePrefix + "datumNeSmeBitiManjiOd" | translate : { minDatum: (minDate | date:'d.MM.yyyy.') }) }}
            </span>
        </mat-error>
    </mat-form-field>
    <h3>{{data.message}}</h3>

    <div fxLayout="row" fxLayoutGap="40px" class="pt-1">
        <div fxFlex="50" fxLayoutGap="10px">
            <button data-testid="btnOtkazi" class="full-width" (click)="cancel()" mat-raised-button color="accent">
                {{ "general.cancel" | translate }}
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div fxFlex="50" fxLayoutGap="10px">
            <button data-testid="btnObrisi" class="full-width" mat-raised-button color="primary"
                (click)="confirm($event)">
                {{ translatePrefix + "reaktiviraj" | translate }}
                <mat-icon>done</mat-icon>
            </button>
        </div>
    </div>
</form>